var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdcionar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 7.5C15 7.73869 14.9052 7.96761 14.7364 8.1364C14.5676 8.30518 14.3387 8.4 14.1 8.4H8.4V14.1C8.4 14.3387 8.30518 14.5676 8.1364 14.7364C7.96761 14.9052 7.73869 15 7.5 15C7.2613 15 7.03239 14.9052 6.8636 14.7364C6.69482 14.5676 6.6 14.3387 6.6 14.1V8.4H0.9C0.661305 8.4 0.432387 8.30518 0.263604 8.1364C0.0948212 7.96761 0 7.73869 0 7.5C0 7.2613 0.0948212 7.03239 0.263604 6.8636C0.432387 6.69482 0.661305 6.6 0.9 6.6H6.6V0.9C6.6 0.661305 6.69482 0.432387 6.8636 0.263604C7.03239 0.0948212 7.2613 0 7.5 0C7.73869 0 7.96761 0.0948212 8.1364 0.263604C8.30518 0.432387 8.4 0.661305 8.4 0.9V6.6H14.1C14.3387 6.6 14.5676 6.69482 14.7364 6.8636C14.9052 7.03239 15 7.2613 15 7.5Z",
    fill: "#171717"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdcionar);
export default __webpack_public_path__ + "static/media/adcionar.5c83764da995a2125ca3e9e0d8c29683.svg";
export { ForwardRef as ReactComponent };